/** Response shape for GET /api/v3/organizers/{id}/collections/ with expand=event_count */
export interface OrganizerCollectionsV3Response {
  pagination?: {
    has_more_items?: boolean;
    page_number?: number;
    page_count?: number;
  };
  collections?: OrganizerCollectionV3Item[];
}

export interface OrganizerCollectionV3Item {
  id?: string;
  event_count?: {
    current_public_future_published?: number;
  };
}

/**
 * Loads all live organizer collections from the public v3 API and maps each collection id to
 * `current_public_future_published` (upcoming public events).
 */
export async function fetchOrganizerCollectionPublicEventCounts(
  organizerId: string,
  fetchImpl: typeof fetch = fetch,
): Promise<Record<string, number>> {
  const counts: Record<string, number> = {};
  let page = 1;
  const maxPages = 100;

  while (page <= maxPages) {
    const params = new URLSearchParams({
      status: 'live',
      expand: 'image,event_count',
      page: String(page),
    });
    const url = `/api/v3/organizers/${encodeURIComponent(organizerId)}/collections/?${params}`;
    const res = await fetchImpl(url, { credentials: 'include' });
    if (!res.ok) {
      throw new Error(`Organizer collections v3 request failed: ${res.status}`);
    }
    const data = (await res.json()) as OrganizerCollectionsV3Response;
    for (const c of data.collections ?? []) {
      const id = c.id?.trim();
      if (id) {
        counts[id] = c.event_count?.current_public_future_published ?? 0;
      }
    }
    if (!data.pagination?.has_more_items) {
      break;
    }
    page += 1;
  }

  return counts;
}
